<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="trash-2-outline"></nb-icon>
        <div class="ml-2" i18n>Deleting Campaign: {{ campaign.id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div *ngIf="campaign.enabled" class="d-flex justify-content-center">
      <h4 i18n>This campaign is active, please deactivate it first!</h4>
    </div>
    <div *ngIf="!campaign.enabled">
      <div class="deep-delete-spinner" *ngIf="spin">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <form #campaignForm="ngForm" *ngIf="!spin" style="max-height: 500px">
        <div class="row">
          <strong class="text-uppercase" i18n>Select associated objects for deletion:</strong>
        </div>
        <div class="row">
          <div class="col">
            <div class="d-flex align-items-center">
              <nb-checkbox
                id="campaign.trigger_id"
                name="deleteInsight"
                [(ngModel)]="delete.insight"
                style="padding: 3px 10px 0px 0px"
                dis
                [disabled]="!insightsIncludes(campaign.trigger_id) || anyCampaignsActive(campaign.trigger_id) > 0"
              ></nb-checkbox>
              <label class="d-flex flex-row" style="padding-top: 6px">
                <div style="padding-right: 4px" i18n>Insight:</div>
                <div *ngIf="insightsIncludes(campaign.trigger_id)">{{ campaign.trigger_id }}</div>
                <div *ngIf="!insightsIncludes(campaign.trigger_id)" i18n>Not found</div>
              </label>
              <button
                *ngIf="campaign.trigger_id && insightsIncludes(campaign.trigger_id)"
                nbButton
                size="medium"
                ghost
                status="info"
                (click)="viewInsight(campaign.trigger_id)"
              >
                <nb-icon icon="external-link-outline" i18n-nbTooltip nbTooltip="View Insight"></nb-icon>
              </button>
            </div>
            <div *ngIf="insightsIncludes(campaign.trigger_id)">
              <p style="color: green" status="success" *ngIf="affectedCampaigns.insight.length - 1 === 0" i18n>
                No campaigns would be affected by deletion of this insight
              </p>
              <p style="color: red" *ngIf="anyCampaignsActive(campaign.trigger_id) === 1" i18n>
                An active campaign is using this insight. Deactivate it before deleting this insight!
              </p>
              <p style="color: red" *ngIf="anyCampaignsActive(campaign.trigger_id) > 1" i18n>
                Multiple active campaigns are using this insight. Deactivate them before deleting this insight!
              </p>
              <p style="color: orange" *ngIf="affectedCampaigns.insight.length - 1 > 0" i18n>
                The following campaigns are connected to this insight:
              </p>
              <ul *ngFor="let c of affectedCampaigns.insight">
                <li *ngIf="c.id !== campaign.id">
                  {{ c.name }} <strong>[{{ c.status }}]</strong>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <br />

        <div class="row">
          <div class="col">
            <div class="d-flex align-items-center">
              <nb-checkbox
                id="campaign.content_id"
                name="deleteContent"
                [(ngModel)]="delete.content"
                style="padding: 3px 10px 0px 0px"
                [disabled]="
                  !contentsIncludes(campaign.content_id) || anyCampaignsActive(false, campaign.content_id) > 0
                "
              ></nb-checkbox>
              <label class="d-flex flex-row" style="padding-top: 6px">
                <div style="padding-right: 4px" i18n>Content:</div>
                <div *ngIf="contentsIncludes(campaign.content_id)">{{ campaign.content_id }}</div>
                <div *ngIf="!contentsIncludes(campaign.content_id)" i18n>Not found</div>
              </label>
              <button
                *ngIf="campaign.content_id && contentsIncludes(campaign.content_id)"
                nbButton
                size="medium"
                ghost
                status="info"
                (click)="viewContent(campaign.content_id)"
              >
                <nb-icon icon="external-link-outline" i18n-nbTooltip nbTooltip="View Content"></nb-icon>
              </button>
            </div>
            <div *ngIf="contentsIncludes(campaign.content_id)">
              <p style="color: green" *ngIf="affectedCampaigns.content.length - 1 === 0" i18n>
                No campaigns would be affected by deletion of this content
              </p>
              <p style="color: red" *ngIf="anyCampaignsActive(false, campaign.content_id) === 1" i18n>
                An active campaign is using this content. Deactivate it before deleting this content!
              </p>
              <p style="color: red" *ngIf="anyCampaignsActive(false, campaign.content_id) > 1" i18n>
                Multiple active campaigns are using this content. Deactivate them before deleting this content!
              </p>
              <p style="color: orange" *ngIf="affectedCampaigns.content.length - 1 > 0" i18n>
                The following campaigns are connected to this content:
              </p>
              <ul *ngFor="let c of affectedCampaigns.content">
                <li *ngIf="c.id !== campaign.id">
                  {{ c.name }} <strong>[{{ c.status }}]</strong>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <br />

        <div *ngFor="let response of campaign.responses">
          <div class="row">
            <div class="col">
              <div class="d-flex align-items-center">
                <nb-checkbox
                  id="response.id"
                  name="deleteSurvey"
                  [(ngModel)]="delete.surveys[response.id]"
                  style="padding: 3px 10px 0px 0px"
                  [disabled]="!surveysIncludes(response.id) || anyCampaignsActive(false, false, response.id) > 0"
                ></nb-checkbox>
                <label class="d-flex flex-row" style="padding-top: 6px">
                  <div style="padding-right: 4px" i18n>Survey:</div>
                  <div *ngIf="surveysIncludes(response.id)">{{ response.id }}</div>
                  <div *ngIf="!surveysIncludes(response.id)" i18n>Not found</div>
                </label>
                <button
                  *ngIf="surveysIncludes(response.id)"
                  nbButton
                  size="medium"
                  ghost
                  status="info"
                  (click)="viewSurvey(response.id)"
                >
                  <nb-icon icon="external-link-outline" i18n-nbTooltip nbTooltip="View Survey"></nb-icon>
                </button>
              </div>
              <div *ngIf="surveysIncludes(response.id)">
                <p style="color: green" *ngIf="affectedCampaigns.surveys[response.id].length - 1 === 0" i18n>
                  No campaigns would be affected by deletion of this survey
                </p>
                <p style="color: red" *ngIf="anyCampaignsActive(false, false, response.id) === 1" i18n>
                  An active campaign is using this survey. Deactivate it before deleting this survey!
                </p>
                <p style="color: red" *ngIf="anyCampaignsActive(false, false, response.id) > 1" i18n>
                  Multiple active campaigns are using this survey. Deactivate them before deleting this survey!
                </p>
                <p style="color: orange" *ngIf="affectedCampaigns.surveys[response.id].length - 1 > 0" i18n>
                  The following campaigns are connected to this survey:
                </p>
                <ul *ngFor="let c of affectedCampaigns.surveys[response.id]">
                  <li *ngIf="c.id !== campaign.id">
                    {{ c.name }} <strong>[{{ c.status }}]</strong>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <br />
      </form>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div *ngIf="!campaign.enabled">
      <div class="d-flex flex-column">
        <p i18n>
          Deleting the campaign and its associated objects is <strong>irreversible</strong> and could possibly affect
          other campaigns.
        </p>
        <label i18n>Type "DELETE" to confirm deletion</label>
        <input nbInput type="string" fieldSize="small" placeholder="DELETE" [(ngModel)]="confirmation" required />
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <button
        nbButton
        class="ml-3"
        status="danger"
        [disabled]="campaign.enabled && confirmation.toLowerCase() !== 'delete'"
        (click)="deepDelete()"
        i18n
      >
        Delete
      </button>
    </div>
  </nb-card-footer>
</nb-card>
